// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".star-rating-stars path[data-v-3dc81662],.star-rating-stars svg[data-v-3dc81662]{height:2.1rem}@media (min-width:768px){.star-rating-stars path[data-v-3dc81662],.star-rating-stars svg[data-v-3dc81662]{height:2.4rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
